(function () {
  const BP = () =>
    window.innerWidth < 768 ? "mobile" : window.innerWidth <= 1024 ? "tablet" : "desktop";

  let currentBP = null;
  let teardown = () => {};

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("resize", onResizeBreakpoint);

  function onResizeBreakpoint() {
    const next = BP();
    if (next !== currentBP) {
      teardown();
      init();
    }
  }

  function init() {
    currentBP = BP();
    if (currentBP === "mobile") teardown = initMobile();
    else if (currentBP === "tablet") teardown = initTabletFlickity();
    else teardown = () => {};
  }

  function ensureBarFill(bar) {
    if (!bar) return null;
    let fill = bar.querySelector(".loading-bar__fill");
    if (!fill) {
      fill = document.createElement("div");
      fill.className = "loading-bar__fill";
      bar.appendChild(fill);
    }
    return fill;
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function getTranslateX(el) {
    const t = getComputedStyle(el).transform;
    if (!t || t === "none") return 0;
    const m3 = t.match(/^matrix3d\((.+)\)$/);
    if (m3) {
      const vals = m3[1].split(",").map(parseFloat);
      return vals[12] || 0;
    }
    const m2 = t.match(/^matrix\((.+)\)$/);
    if (m2) {
      const vals = m2[1].split(",").map(parseFloat);
      return vals[4] || 0;
    }
    const tx = t.match(/translateX\(([-\d.]+)px\)/);
    return tx ? parseFloat(tx[1]) : 0;
  }

  function initMobile() {
    const container = document.querySelector(".tab-collections__container");
    const scroller = container?.querySelector(".carousel--mobile");
    const guide = container?.querySelector(".mobile-slide-steps");
    const bar = document.querySelector(".loading-bar");
    if (!container || !scroller || !bar) return () => {};

    const fill = ensureBarFill(bar);

    function updateBar() {
      const max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 0) {
        bar.classList.add("is-hidden");
        fill && (fill.style.width = "0%");
        return;
      }
      bar.classList.remove("is-hidden");
      const pct = (scroller.scrollLeft / max) * 100;
      fill && (fill.style.width = pct + "%");
    }

    scroller.addEventListener("scroll", updateBar, { passive: true });
    window.addEventListener("resize", updateBar);
    let roBar = null;
    if ("ResizeObserver" in window) {
      roBar = new ResizeObserver(updateBar);
      roBar.observe(scroller);
    }
    updateBar();

    if (!guide || guide.children.length < 3) {
      return () => {
        scroller.removeEventListener("scroll", updateBar);
        window.removeEventListener("resize", updateBar);
        roBar?.disconnect();
      };
    }

    let prodStops = [];
    let guideStops = [];

    function sizeGuideSteps() {
      const items = [...scroller.querySelectorAll(".carousel__item")];
      if (items.length < 4) return;

      const mr = (el) => parseFloat(getComputedStyle(el).marginRight) || 0;
      const left = (el) => el.offsetLeft;
      const span = (a, b) => (items[b] ? left(items[b]) - left(items[a]) : 0);
      const single = (i) => items[i].offsetWidth + mr(items[i]);

      const w1 = Math.round((items[1] ? span(0, 1) : single(0)) - 20);
      const w2 = Math.round(span(1, 3) - 20);
      const w3 = Math.round((items[4] ? span(3, 4) : single(3)) - 20);

      const [s1, s2, s3] = guide.children;
      s1.style.minWidth = w1 + "px";
      s2.style.minWidth = w2 + "px";
      s3.style.minWidth = w3 + "px";

      prodStops = [0, items[1].offsetLeft, items[3].offsetLeft];
      guideStops = [0, s2.offsetLeft, s3.offsetLeft];
    }

    function syncGuideScroll() {
      const scroll = scroller.scrollLeft;
      const maxProd = scroller.scrollWidth - scroller.clientWidth;
      const maxGuide = guide.scrollWidth - guide.clientWidth;

      for (let i = 0; i < prodStops.length - 1; i++) {
        const p1 = prodStops[i], p2 = prodStops[i + 1];
        const g1 = guideStops[i], g2 = guideStops[i + 1];
        if (scroll >= p1 && scroll <= p2) {
          const t = (scroll - p1) / (p2 - p1);
          guide.scrollLeft = g1 + t * (g2 - g1);
          return;
        }
      }
      if (scroll >= maxProd) {
        guide.scrollLeft = maxGuide;
      }
    }

    let ticking = false;
    function onProductScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        updateBar();
        syncGuideScroll();
        ticking = false;
      });
    }

    sizeGuideSteps();
    syncGuideScroll();

    scroller.addEventListener("scroll", onProductScroll, { passive: true });
    function onResizeMobile() {
      sizeGuideSteps();
      syncGuideScroll();
      updateBar();
    }
    window.addEventListener("resize", onResizeMobile);

    let ro = null;
    if ("ResizeObserver" in window) {
      ro = new ResizeObserver(() => {
        sizeGuideSteps();
        syncGuideScroll();
        updateBar();
      });
      ro.observe(scroller);
    }

    return () => {
      scroller.removeEventListener("scroll", updateBar);
      window.removeEventListener("resize", updateBar);
      scroller.removeEventListener("scroll", onProductScroll);
      window.removeEventListener("resize", onResizeMobile);
      roBar?.disconnect();
      ro?.disconnect();
    };
  }

  function initTabletFlickity() {
    const container = document.querySelector(".tab-collections__container");
    const root = container?.querySelector(".carousel--mobile.flickity-enabled");
    const viewport = root?.querySelector(".flickity-viewport");
    const slider = root?.querySelector(".flickity-slider");
    const bar = document.querySelector(".loading-bar");
    const guide = container?.querySelector(".mobile-slide-steps");

    if (!container || !root || !viewport || !slider || !bar) return () => {};

    const fill = ensureBarFill(bar);

    function updateBarFlickity() {
      const max = slider.scrollWidth - viewport.clientWidth;
      if (max <= 0) {
        bar.classList.add("is-hidden");
        fill && (fill.style.width = "0%");
        return;
      }
      bar.classList.remove("is-hidden");
      const tx = -getTranslateX(slider);
      const pct = clamp((tx / max) * 100, 0, 100);
      fill && (fill.style.width = pct + "%");
    }

    function sizeGuideStepsFlickity() {
      if (!guide || guide.children.length < 3) return;
      const items = [...slider.querySelectorAll(".carousel__item")];
      if (items.length < 4) return;

      const w = (i) => items[i].getBoundingClientRect().width || items[i].offsetWidth;
      const w1 = Math.round(w(0) - 20);
      const w2 = Math.round(w(1) + w(2) - 20);
      const w3 = Math.round(w(3) - 20);

      const [s1, s2, s3] = guide.children;
      s1.style.minWidth = w1 + "px";
      s2.style.minWidth = w2 + "px";
      s3.style.minWidth = w3 + "px";
    }

    function syncGuideFlickity() {
      if (!guide) return;
      const maxProd = slider.scrollWidth - viewport.clientWidth;
      const maxGuide = guide.scrollWidth - guide.clientWidth;
      if (maxProd <= 0 || maxGuide <= 0) return;
      const tx = -getTranslateX(slider);
      const ratio = clamp(tx / maxProd, 0, 1);
      guide.scrollLeft = ratio * maxGuide;
    }

    function updateAll() {
      updateBarFlickity();
      sizeGuideStepsFlickity();
      syncGuideFlickity();
    }

    const mo = new MutationObserver(() => {
      updateAll();
    });
    mo.observe(slider, { attributes: true, attributeFilter: ["style"] });

    let rafId = null;
    function startRAF() {
      if (rafId) return;
      const loop = () => {
        updateAll();
        rafId = requestAnimationFrame(loop);
      };
      rafId = requestAnimationFrame(loop);
    }
    function stopRAF() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    viewport.addEventListener("pointerdown", startRAF, { passive: true });
    window.addEventListener("pointerup", stopRAF, { passive: true });
    window.addEventListener("pointercancel", stopRAF, { passive: true });

    const prev = root.querySelector(".flickity-prev-next-button.previous");
    const next = root.querySelector(".flickity-prev-next-button.next");
    const onClickBtn = () => {
      startRAF();
      setTimeout(stopRAF, 600);
    };
    prev?.addEventListener("click", onClickBtn);
    next?.addEventListener("click", onClickBtn);

    // Resizes
    function onResize() {
      updateAll();
    }
    window.addEventListener("resize", onResize);

    let roViewport = null;
    let roGuide = null;
    if ("ResizeObserver" in window) {
      roViewport = new ResizeObserver(updateAll);
      roViewport.observe(viewport);
      if (guide) {
        roGuide = new ResizeObserver(updateAll);
        roGuide.observe(guide);
      }
    }

    updateAll();

    return () => {
      mo.disconnect();
      stopRAF();
      viewport.removeEventListener("pointerdown", startRAF);
      window.removeEventListener("pointerup", stopRAF);
      window.removeEventListener("pointercancel", stopRAF);
      prev?.removeEventListener("click", onClickBtn);
      next?.removeEventListener("click", onClickBtn);
      window.removeEventListener("resize", onResize);
      roViewport?.disconnect();
      roGuide?.disconnect();
    };
  }
})();
